module.exports = {
  TYPES: {
    NONE: 'none',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error'
  }
};
